import styled from "styled-components"

import { Paragraph, ParagraphSmall } from "components/text"

type LabelWithImageProps = {
  checked?: boolean
}

export const Label = styled(ParagraphSmall).attrs({ as: "label" })<LabelWithImageProps>`
  position: relative;
  display: flex;

  background-color: ${props => (props.checked ? props.theme.colors.paleAqua : props.theme.colors.iceBlue)};
  border: 1px solid ${props => props.theme.colors.evergreen};
  border-radius: ${props => props.theme.space[2]};

  transition: background-color 0.2s;

  :hover {
    cursor: pointer;
    background-color: ${props => props.theme.colors.paleAqua};
  }

  :focus-within {
    box-shadow: 0 2px 5px ${props => props.theme.colors.melrose}, 0 2px 5px ${props => props.theme.colors.melrose},
      0 2px 5px ${props => props.theme.colors.melrose};
  }
`

export const BoxLabel = styled(Label)`
  flex-direction: column;
  align-items: center;
  flex: 1;
  padding-top: ${props => props.theme.space[6]};
  padding-bottom: ${props => props.theme.space[6]};

  svg {
    flex: 1;
  }
`

export const RowLabel = styled(Label)`
  box-sizing: border-box;
  flex-direction: row;
  flex: 1;
  width: 100%;

  padding: ${props => props.theme.space[4]} ${props => props.theme.space[5]};

  svg {
    height: 40px;
    width: 40px;
    align-self: center;

    margin-top: ${props => props.theme.space[2]};
    margin-bottom: ${props => props.theme.space[2]};
    margin-right: ${props => props.theme.space[7]};
    margin-left: ${props => props.theme.space[5]};
  }

  :not(:last-of-type) {
    margin-bottom: ${props => props.theme.space[3]};
  }
`

export const Title = styled(Paragraph)`
  display: inline-flex;
  align-self: center;
`
